import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

import { LegacyRoutes } from '@legacy/constants';
import { JsToNgService } from '@ng2/services';
import { FroalaComponent } from '@shared/components/froala/froala.component';
import { ModuleIconListComponent } from '@shared/components/module-icon-list/module-icon-list.component';
import { ModuleIconComponent } from '@shared/components/module-icon/module-icon.component';
import { VideoPlayerComponent } from '@shared/components/video-player/video-player.component';

export const Ng1ModuleLegacy = angular
  .module('ng1module.legacy', [])
  .directive('itvModuleIcon', downgradeComponent({ component: ModuleIconComponent }) as angular.IDirectiveFactory)
  .directive(
    'itvModuleIconList',
    downgradeComponent({ component: ModuleIconListComponent }) as angular.IDirectiveFactory,
  )
  .directive('appFroala', downgradeComponent({ component: FroalaComponent }) as angular.IDirectiveFactory)
  .directive('cipoVideoPlayer', downgradeComponent({ component: VideoPlayerComponent }) as angular.IDirectiveFactory)
  .factory('legacyRoutes', downgradeInjectable(LegacyRoutes) as any)
  .factory('jsToNg', downgradeInjectable(JsToNgService)).name;
